import React from 'react'
import SecurityComp from '../Components/securitysection/SecurityComp'

function Security() {
  return (
    <>
    <SecurityComp />
    </>
  )
}

export default Security